module.exports = __webpack_public_path__ + "img/jin_rong.d6832933.png";